import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { RateSyncChannelService } from 'src/app/components/Shared/Service/rate-sync-channel.service';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import {ToastrService} from 'ngx-toastr'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { IdsProductsService } from '../Shared/Service/ids-products.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
    id: number;
    status: String;
    hotelName: String;
    accountingDate: any;
    pusheddate: any;
    type:any
}
@Component({
  selector: 'app-fxservicelog',
  templateUrl: './fxservicelog.component.html',
  styleUrls: ['./fxservicelog.component.css','../commonStyle.css'],
  providers: [LoginService, IdsProductsService,RateSyncChannelService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class FxservicelogComponent implements OnInit {
  searchText:any;
  typ:any;
  public PGF: any = "0";
  public PGT: any = "50";
  pageSize = 50;
  pageSizeOptions: number[] = [5, 10, 250, 500];
  isIDSUser: any;
  apiresult: any;
  hotellistChannel: any[];
  hotellistproperty: any;
  ColumnHeader: boolean;
  url: string;
  maxDate: Date;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  filterProperty: any;
  constructor(private apiCallIdsService: DashboarduiService,private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) {
    
  }
  today = new Date();
  today1:any= new Date();
  CurrentDate = new Date();
  selectedDate: any= new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any= new Date(this.today1.setDate(this.today1.getDate() - 1));
  display: Boolean = false;
  totalcount: any = 0;
  hotellistCopy: any = [];
  public idsProductList: idsProductList[];
  // lstidsProductList: MatTableDataSource<idsProductList>;
  dataSource: MatTableDataSource<idsProductList>
  StorelstRestr: any;
  // lstidsProductList:any;
  // dataSource:any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  Val: string;
  selectedProperty: string;
  UID:any;
  selectedChannel: any;
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  // public LOGS: any;
  lstgetcmlist:any[];
  hotellist: any = [];
  allproperty: any[];
  selected: string;
  Userid: any = [];
  displayedColumns: string[] = ['hotelName','heartbeat', 'totalCount','lastrequestdate', 'departmentName', 'romnum','createdatetime'];
  heartBeatData: any;
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems:any;
  dropdownDeptData: any
  checkTodayDate:any
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean = false;
  checkTimeMins:any
  storeTimeDiff = 60
  ngOnInit() {
    console.log('storeTimeDiff = ',this.storeTimeDiff)
    this.currentDateStore = this.datePipe.transform(this.today, 'mm dd yyyy HH:MM');
    console.log('currentDateStore = ',this.currentDateStore)
    // return (d.substring(12, 13));
    this.checkTodayDate = this.CurrentDate.getDate()
    console.log('check Today =', this.checkTodayDate)
    // console.log('checkTodayDate =', this.currentDateStore.substring(11, 13))
    // this.checkTodayDate = this.currentDateStore.substring(11, 13)


    // this.currentDateStore = this.datePipe.transform(this.CurrentDate, 'dd mm yyyy HH:MM');
    // console.log('checkTimeMins =', this.currentDateStore.substring(13, 15))
    // this.checkTimeMins = this.currentDateStore.substring(13, 15)
    this.isProgressing = true;
      this.loadMethod();
      this.dropdownSettingsDept = {
        idField: 'propertyCode',
        textField: 'propertyName',
        allowSearchFilter: true,
        singleSelection: true,
        enableCheckAll: false,
        closeDropDownOnSelection: true,
        itemsShowLimit: 7,
        noDataAvailablePlaceholderText: 'No Data Found',
        searchPlaceholderText: "Search Hotel Code / Name"
      };
  }

  loadMethod(){
    // this.isProgressing = true
        this.apiCallIdsService.readFXServiceLogReadAPI()
        .subscribe(
          data => {
            console.log('readBWCRMReadAPIData Data =', data)
            if(data.length >0){
              this.errorMsgSubscription = false
              this.displayContent = true
            this.idsProductList=data;
            this.filterProperty = this.idsProductList
          this.dataSource = new MatTableDataSource(this.idsProductList);
          this.dataSource.paginator = this.paginator;
          this.toastr.success('Data Loaded Successfully');
          this.isProgressing = false;
          }else{
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          },
          );
  }

  GetHeartbeatDateTime(heartBeatData:any) {
    console.log('GetHeartbeatDateTime call',heartBeatData)
// For blinking the record
const today = new Date()
        console.log('Today Date = ',today);
        this.currentDateStore = today.toLocaleTimeString('it-IT')
        console.log('Today Date = ',this.currentDateStore);
        this.storeHeartBeatValue = this.GetHeartbeatTime(heartBeatData)
// this.storeHeartBeatValue = heartBeatData
var start = this.storeHeartBeatValue.split(":");
var end = this.currentDateStore.split(":");
var startDate = new Date(0, 0, 0, start[0], start[0], 0);
var endDate = new Date(0, 0, 0, end[0], end[0], 0);
var diff = endDate.getTime() - startDate.getTime();
var hours = Math.floor(diff / 1000 / 60 / 60);
diff -= hours * 1000 * 60 * 60;
var minutes = Math.floor(diff / 1000 / 60);
console.log('minutes difference', hours + ":"  + minutes)
if((hours + ":"  + minutes) > "0:30"){
  console.log('blinkOfflineHotel true')
  this.blinkOfflineHotel = true
  // return heartBeatData
}else{
  console.log('blinkOfflineHotel false')
  this.blinkOfflineHotel = false
  // return heartBeatData
} 
return heartBeatData
  }

  GetHeartbeatTime(d:any) {
    console.log('GetHeartbeatTime call = ',d.substring(12))
    return (d.substring(12));
  }

  SearchHotels(event:any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { hotelName: { toString: () => string; }}) => {
      return res.hotelName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if(event == ''){
      this.Val = '';
    }
  }

  getDimensionsByFilter(propertyCode:any){
    console.log('dropdownDeptData =',this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }


  GetParseonlyDateTime(d:any) {
    console.log('GetParseonlyDateTime call',d)
    if (d == "") {
      return "";
    }
    console.log('GetParseonlyDateTime = ',d.substring(4, 7))
    return (d.substring(4, 7));
  }

  GetParseonlyDateTimeHeartbeat(d:any) {
var dt1 = new Date(d);
var dt2 = new Date();
// console.log('dt1 = ',dt1)
// console.log('dt2 = ',dt2)
var diff =(dt2.getTime() - dt1.getTime()) / 1000;
diff /= 60;
// console.log('Math ABS = ',Math.abs(Math.round(diff)));
if(Math.abs(Math.round(diff)) > 60){
  return false
}else{
  return true
}
  }


//   diff_minutes(dt2:any, dt1:any) 
//  {
//   // console.log('dt1 = ',dt1)
//   // console.log('dt2 = ',dt2)
//   var diff =(dt2.getTime() - dt1.getTime()) / 1000;
//   diff /= 60;
//   // console.log('Math ABS = ',Math.abs(Math.round(diff)));
//   if(Math.abs(Math.round(diff)) > 60){
//     return false
//   }else{
//     return true
//   }
//   // return Math.abs(Math.round(diff))
//  }


  GetParseonlyDateTimeMins(d:any) {
    console.log('GetParseonlyDateTimeMins',d)
    if (d == "") {
      return "";
    }
    console.log('GetParseonlyDateTimeMins = ',d.substring(15, 17))
    return (d.substring(15, 17));
  }
  pageEvent(e) {
    console.log(e)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } 

}

